import React, { useEffect, useState } from 'react'
import axios from 'axios'
import AdminMenu from '../components/AdminMenu'; // ajusta la ruta si estás en una subcarpeta


function AdminPanel() {
  const [usuarios, setUsuarios] = useState([])

  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        const res = await axios.get('/api/usuarios')
        setUsuarios(res.data)
      } catch (err) {
        console.error('Error cargando usuarios', err)
      }
    }

    fetchUsuarios()
  }, [])

  return (
    <div>
      <h2>Panel de Administrador</h2>
      <table>
        <thead>
          <tr>
            <th>Usuario</th>
            <th>Servidor</th>
            <th>Fecha Expiración</th>
            <th>Max Dispositivos</th>
          </tr>
        </thead>
        <tbody>
          {usuarios.map((u) => (
            <tr key={u.id}>
              <td>{u.username}</td>
              <td>{u.servidor}</td>
              <td>{new Date(u.fechaexp).toLocaleDateString()}</td>
              <td>{u.maxdispositivos}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default AdminPanel
